var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"centerLeft1"}},[_vm._m(0),_c('rightCenterChart')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('span',{staticClass:"text"},[_vm._v("每月销售额统计")])])
}]

export { render, staticRenderFns }